function getAlmacenes(){
    return window.axios.get('/api/almacen/index');
}
function postAlmacen(data){
    return window.axios.post('/api/almacen/create',data);
}

export default {
    getAlmacenes,postAlmacen
}